module.exports = "## Bulk image converter\r\n\r\nNeed to convert multiple images? Our image editor allows you to convert your images to any of the following file types; jpg, png, gif, and bmp."


//////////////////
// WEBPACK FOOTER
// ./src/containers/BulkResize/bulk-image-converter.md
// module id = 1135
// module chunks = 0